import getLazadaAuthUrl from 'lib/lazada/getLazaAuthUrl';

const LAZADA_AUTH_WINDOW = 'LAZADA_AUTH_WINDOW';

const openLazadaAuthWindow = () => {
  return getLazadaAuthUrl().then((url) => {
    return window.open(url, LAZADA_AUTH_WINDOW, 'resizable,scrollbars,status');
  });
};

export default openLazadaAuthWindow;
